export const lmFilterDropdownKeydownFunction = (
  event: any
) => {
  const target = event?.target ? event.target as HTMLElement : null;
  if (target &&
    target.classList.contains('dropdown') &&
    target.parentElement.parentElement.classList.contains('datagrid-filter-wrapper')
  ) {
    if (event.which === 13) {
      //this will run filter if field is entered

      let grid: any;
      let gridInst: any;

      if (target.closest('div[role=datagrid]')) {
        grid = target.closest('div[role=datagrid]');
        gridInst = $(grid).data('datagrid');
      } else if (target.closest('div[role=treegrid]')) {
        grid = target.closest('div[role=treegrid]');
        gridInst = $(grid).data('datagrid');
      }

      gridInst?.applyFilter();
      return false;
    } else if (event.which === 32) {
      return true;
    }
  }
};
